import { render, staticRenderFns } from "./MediaSearchAudio.vue?vue&type=template&id=6bec6e64&scoped=true&lang=pug"
import script from "./MediaSearchAudio.vue?vue&type=script&lang=js"
export * from "./MediaSearchAudio.vue?vue&type=script&lang=js"
import style0 from "./MediaSearchAudio.vue?vue&type=style&index=0&id=6bec6e64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bec6e64",
  null
  
)

export default component.exports